export * from './delete-herausgeber.service';
export * from './delete-herausgeber.service.module';